'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _linksoftAlbatros = require('linksoft-albatros');

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _FormInput = require('../FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _InlineTooltip = require('../InlineTooltip');

var _InlineTooltip2 = _interopRequireDefault(_InlineTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

var UserInterfaceType = {
    "none": 0,
    "financialInstitutions": 1,
    "accountNumberPin": 2
};

function mapStateToProps(state) {
    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
    return {
        paymentTypeId: options.paymentTypeId,
        financialInstitutionId: options.financialInstitutionId,
        deliveryTypeId: options.deliveryTypeId,
        allowedDeliveryPayments: state.cart.allowedDeliveryPayments
    };
}

var mapDispatchToProps = {
    saveOptions: _actions2.default.saveOptions,
    updatePaymentType: _actions2.default.updatePaymentType
};

var PaymentTypeItem = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(PaymentTypeItem, _React$PureComponent);

    function PaymentTypeItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PaymentTypeItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PaymentTypeItem.__proto__ || (0, _getPrototypeOf2.default)(PaymentTypeItem)).call.apply(_ref, [this].concat(args))), _this), _this.itemChecked = function (e) {
            var id = parseInt(e.target.value, 10);
            if (id !== _this.props.paymentTypeId) {
                _this.props.updatePaymentType(id);
            }
        }, _this.bankChecked = function (e) {
            var id = parseInt(e.target.value, 10);
            var prevId = _this.props.financialInstitutionId ? _this.props.financialInstitutionId : null;
            if (id !== prevId) {
                _this.props.saveOptions({
                    financialInstitutionId: id
                });
            }
        }, _this.isAllowed = function () {
            var _this$props = _this.props,
                id = _this$props.id,
                allowedDeliveryPayments = _this$props.allowedDeliveryPayments,
                deliveryTypeId = _this$props.deliveryTypeId;

            if (typeof deliveryTypeId === 'number') {
                var allowedPaymentTypeIds = allowedDeliveryPayments.filter(function (x) {
                    return x.deliveryTypeId === deliveryTypeId;
                }).map(function (x) {
                    return x.paymentTypeId;
                });
                return allowedPaymentTypeIds.indexOf(id) >= 0;
            }
            return true;
        }, _this.pinChanged = function (e) {
            _this.props.changeState('accountPin', e.target.value);
        }, _this.accountNumberChanged = function (e) {
            _this.props.changeState('accountNumber', e.target.value);
        }, _this.renderFinancialInstitutions = function () {
            var financialInstitutions = _this.props.financialInstitutions;

            return _react2.default.createElement(
                'div',
                { className: 'form-radio__child' },
                financialInstitutions.map(function (item) {
                    return _this.renderFinancialInstitution(item);
                })
            );
        }, _this.renderFinancialInstitution = function (item) {
            var htmlId = 'paymentBank_' + item.id;
            var isSelected = item.id === _this.props.financialInstitutionId;
            var imgUrl = '//' + location.host + '/Content/images/banks/' + item.reference + '.png';
            return _react2.default.createElement(
                'div',
                { className: 'form__radio form__radio--row no-br', key: htmlId },
                _react2.default.createElement('input', { type: 'radio', name: 'paymentBank', value: item.id, id: htmlId, checked: isSelected, onChange: _this.bankChecked }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: htmlId },
                    _react2.default.createElement(
                        'span',
                        { className: 'label__text' },
                        item.name
                    ),
                    _react2.default.createElement('img', { src: imgUrl })
                )
            );
        }, _this.renderAccountNumberAndPin = function () {
            return _react2.default.createElement(
                'div',
                { className: 'form-radio__child' },
                _react2.default.createElement(_FormInput2.default, {
                    name: 'accountNumber',
                    className: '',
                    maxLength: '20',
                    label: Resx.App.BenefityCzAccountLabel,
                    isRequired: 'true',
                    onChange: _this.accountNumberChanged,
                    value: _this.props.accountNumber || '' }),
                _react2.default.createElement(_FormInput2.default, {
                    name: 'accountPin',
                    className: '',
                    maxLength: '20',
                    label: Resx.App.BenefityCzPinLabel,
                    isRequired: 'true',
                    onChange: _this.pinChanged,
                    value: _this.props.accountPin || '' })
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PaymentTypeItem, [{
        key: 'render',
        value: function render() {
            if (!this.isAllowed()) return null;
            var _props = this.props,
                id = _props.id,
                reference = _props.reference,
                name = _props.name,
                paymentPrice = _props.paymentPrice,
                paymentTypeId = _props.paymentTypeId,
                description = _props.description,
                financialInstitutions = _props.financialInstitutions,
                userInterface = _props.userInterface;

            var htmlId = 'payment_' + reference;
            var isSelected = id === paymentTypeId;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form__radio form__radio--row no-br payment-types' },
                    _react2.default.createElement('input', { type: 'radio', name: 'payment', value: id, id: htmlId, checked: isSelected, onChange: this.itemChecked }),
                    _react2.default.createElement(
                        'label',
                        { htmlFor: htmlId },
                        _react2.default.createElement(
                            'span',
                            { className: 'label__text' },
                            name
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'label__last' },
                            paymentPrice > 0 ? (0, _linksoftAlbatros.formatPrice)(paymentPrice, _linksoftAlbatros.PriceType.CartTotalPrice) : Resx.App.FreeOfCharge
                        )
                    ),
                    userInterface === UserInterfaceType.financialInstitutions && financialInstitutions.length > 0 && isSelected && this.renderFinancialInstitutions(),
                    !!description && isSelected && _react2.default.createElement(_InlineTooltip2.default, { text: description })
                ),
                userInterface === UserInterfaceType.accountNumberPin && isSelected && this.renderAccountNumberAndPin()
            );
        }
    }]);
    return PaymentTypeItem;
}(_react2.default.PureComponent), _class2.propTypes = {
    id: _propTypes2.default.number.isRequired,
    reference: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    paymentPrice: _propTypes2.default.number,
    paymentTypeId: _propTypes2.default.number,
    financialInstitutionId: _propTypes2.default.number,
    deliveryTypeId: _propTypes2.default.number,
    allowedDeliveryPayments: _propTypes2.default.array,
    financialInstitutions: _propTypes2.default.array,
    userInterface: _propTypes2.default.number,
    changeState: _propTypes2.default.func.isRequired,
    accountNumber: _propTypes2.default.string,
    accountPin: _propTypes2.default.string
}, _temp2)) || _class);
exports.default = PaymentTypeItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step2/PaymentTypeItem.js
// module id = 1026
// module chunks = 0